import React from "react";
import { useParams } from "react-router-dom";
import ProductLandingPage from "components/ProductLandingPage";
import NotFound from "pages/NotFound";
import { getProductConfig } from "./productConfigs";

export default function ProductPage() {
    const { slug } = useParams();
    const config = getProductConfig(slug);
    if (!config) return <NotFound />;
    return <ProductLandingPage config={config} />;
}
